import React from 'react';
import { Box, Container, Typography } from '@mui/material';

import { Button, Link } from 'gatsby-theme-material-ui';
import SvgImsKit from './SvgImsKit';

export default function AutumnBanner({
  banner,
  isMobile,
  setIsModalOpen,
  handleClick,
}) {
  let buttonHandle = null;
  if (banner.buttonAction === 'modal') {
    buttonHandle = () => setIsModalOpen && setIsModalOpen(true);
  }
  if (banner.buttonAction === 'link') {
    buttonHandle = handleClick;
  }
  const button = (
    <Button
      size={isMobile ? 'smallest' : 'medium'}
      variant="kitPrimary"
      onClick={buttonHandle}
      sx={{
        height: { sm: 38, lg: 'fit-content' },
        minWidth: 91,
        position: 'relative',
        zIndex: 999,
      }}
    >
      {banner.buttonText?.split(' ').join(' ')}
    </Button>
  );
  return (
    <Box
      sx={{
        height: { xs: 40, sm: 48, md: 52, lg: 60 },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            background: `linear-gradient(90deg, rgba(255, 239, 38, 0.49) 0%, rgba(255, 224, 0, 0.49) 5.95%, rgba(255, 211, 0, 0.49) 13.03%, rgba(254, 203, 0, 0.49) 20.32%, rgba(253, 200, 0, 0.49) 28.09%, rgba(241, 143, 52, 0.49) 53.5%, rgba(233, 95, 50, 0.49) 71%, rgba(69, 32, 171, 0.49) 100%)`,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <SvgImsKit isMobile={isMobile} />
        </Box>
      </Box>
      <Container
        maxWidth={'xl'}
        sx={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          justifyContent: { xs: 'flex-start', md: 'flex-end' },
          px: { xs: 'calc(48vw - 158px)', sm: 8, md: 12, lg: 26 },
          gap: { xs: 'calc(30vw - 100px)', md: 4, lg: 8, xl: 10 },
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            minWidth: 157,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            ml: { xs: 0, lg: 18, xl: 'calc(865px - 50vw)' },
          }}
        >
          <Typography
            variant="desktopH4"
            sx={{
              color: 'kit.infographic.darkPurple',
              fontSize: { xs: 12, sm: 14, md: 18, lg: 20 },
              fontWeight: { xs: 400, lg: 700 },
              minWidth: { xs: 10, md: 161 },
              maxWidth: { xs: 190, md: 456, lg: 'none' },
              letterSpacing: { xs: -0.2, md: -0.25 },
            }}
          >
            {isMobile
              ? banner.bannerMobileText.split('\\n')[0]
              : banner.bannerDesktopText.split('\\n')[0]}
          </Typography>

          <Typography
            variant="desktopH5"
            sx={{
              color: 'kit.infographic.darkPurple',
              fontSize: { xs: 12, sm: 14, md: 18, lg: 20 },
              fontWeight: 400,
            }}
          >
            {isMobile
              ? banner.bannerMobileText.split('\\n')[1]
              : banner.bannerDesktopText.split('\\n')[1]}
          </Typography>
        </Box>
        <Box sx={{ ml: 5 }}>
          {banner.buttonAction === 'link' && (
            <Link
              href={banner.buttonLink}
              target="_blank"
              underline="none"
              children={button}
            />
          )}
          {banner.buttonAction === 'modal' && button}
        </Box>{' '}
      </Container>
    </Box>
  );
}
